var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 901,
    height: 782,
    viewBox: "0 0 901 782",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.5 778C697.095 778 897 578.095 897 331.5C897 84.9049 697.095 -115 450.5 -115C203.905 -115 4 84.9049 4 331.5C4 578.095 203.905 778 450.5 778ZM901 331.5C901 580.304 699.304 782 450.5 782C201.696 782 0 580.304 0 331.5C0 82.6957 201.696 -119 450.5 -119C699.304 -119 901 82.6957 901 331.5ZM450.498 659.447C631.62 659.447 778.448 512.619 778.448 331.498C778.448 150.376 631.62 3.54793 450.498 3.54793C269.376 3.54793 122.548 150.376 122.548 331.498C122.548 512.619 269.376 659.447 450.498 659.447ZM782.448 331.498C782.448 514.829 633.829 663.447 450.498 663.447C267.167 663.447 118.548 514.829 118.548 331.498C118.548 148.167 267.167 -0.452072 450.498 -0.452072C633.829 -0.452072 782.448 148.167 782.448 331.498ZM459.339 456.788L485.695 392.875L387.618 295.008L323.606 321.541L276.616 274.556L273.518 271.459L277.609 269.893L579.049 154.519L627.482 202.908L512.205 504.384L510.638 508.484L507.546 505.368L459.339 456.788ZM386.086 291.313L324.544 316.823L280.707 272.991L578.057 159.182L622.819 203.904L509.114 501.269L464.05 455.857L489.393 394.4L490.411 391.93L488.52 390.043L390.443 292.177L388.553 290.291L386.086 291.313ZM350.726 366.63L307.165 471.725L304.999 476.95L310.226 474.788L415.42 431.266L419.422 429.61L416.358 426.549L355.445 365.691L352.383 362.632L350.726 366.63ZM353.788 369.689L312.391 469.563L412.356 428.204L353.788 369.689Z",
    fill: "url(#paint0_linear_29947_10150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29947_10150",
    x1: 175.085,
    y1: -175.067,
    x2: 527.223,
    y2: 433.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB57",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPremium);
export default __webpack_public_path__ + "static/media/logo-premium.d23f47472c05de6aeface5fce4df3681.svg";
export { ForwardRef as ReactComponent };